import React from 'react';
import Badge, { BadgeSize } from './Badge';
import { SaleBadgeContainer, SaleBadgeLabel } from './styled';
var SaleBadge = function SaleBadge(_ref) {
  var children = _ref.children,
    className = _ref.className,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(SaleBadgeContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(Badge, {
    size: size
  }), /*#__PURE__*/React.createElement(SaleBadgeLabel, null, children));
};
export default SaleBadge;
export { BadgeSize };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBadge/SaleBadge.js
// module id = 841
// module chunks = 11